









































import mixins from '../../mixins';

export default mixins().extend({
  props: {
    value: { default: undefined, type: undefined },
    multiple: { default: false, type: Boolean },
    mandatory: { default: false, type: Boolean },
    iconLeft: { default: undefined, type: String },
    iconRight: { default: undefined, type: String },
    color: { default: undefined, type: String },
    tag: { default: 'div', type: String },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.selected = this.value;
      },
    },
  },
  methods: {
    onExpanderClick() {
      this.$emit('click');
    },
  },
  data: () => ({
    selected: undefined as any,
    isExpanded: false,
  }),
});
